import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { styles } from '../../style/style';

export default function Dashboard() {
    return(
        <Box >
        <Grid container sx={styles.masterMargin}>
            <Typography id="newsTableTitle" variant="h2" sx ={styles.h2PageTitle}><><FormattedMessage id="maintenanceTable.newsTitle" defaultMessage='News Message Table'/></></Typography>
                <Grid container sx={styles.tablePadding}>
                   {/* Insert News Stuff Here */}
                </Grid>
        </Grid>
    </Box>
    )
}